A time period for which an associated object is effective.
